import { ADMINISTRATION_ROUTING } from "./administration-routing";
import { ORGANIZATION_ADMIN_ROUTING } from "./organization-admin-routing";
import { RouteParameters } from "./route-parameters";

const ORGANIZATION_MANAGEMENT_ROUTES = [
  ADMINISTRATION_ROUTING.ROOT,
  ADMINISTRATION_ROUTING.AIRPLANES,
  ADMINISTRATION_ROUTING.SUPPORT_VEHICLES,
  ADMINISTRATION_ROUTING.AIRPLANES_CLAIM,
  ADMINISTRATION_ROUTING.USERS,
  ADMINISTRATION_ROUTING.ORGANIZATION,
  ADMINISTRATION_ROUTING.PENDING_RISK_ASSESSMENTS,
  ADMINISTRATION_ROUTING.TRANSACTIONS,
  ADMINISTRATION_ROUTING.CHECKOUT[RouteParameters.CHECKOUT_ID].ROOT,
  ORGANIZATION_ADMIN_ROUTING.ORGANIZATION_MANAGEMENT.ROOT,
  ORGANIZATION_ADMIN_ROUTING.CHECKOUT[RouteParameters.CHECKOUT_ID].ROOT,
] as const;

export { ORGANIZATION_MANAGEMENT_ROUTES };
